export const CAMERA_OPTIONS_TYPES = [
  { label: "Giám sát đăng kiểm", value: 1 },
  { label: "Giám sát nhân viên", value: 2 },
  { label: "Giám sát trung tâm", value: 3 },
];

export const CAMERA_OPTIONS_CONNECTION_STATUS = [
  { label: "Online", value: "online" },
  { label: "Offline", value: "offline" },
  { label: "Lỗi", value: "error" },
];

export const CAMERA_OPTIONS_STATUS = [
  { label: "Hoạt động", value: "online" },
  { label: "Không hoạt động", value: "offline" },
];

export const CAMERA_RESOLUTION_OPTIONS = [
  {
    value: "1280x720",
    label: "1280x720",
  },
  {
    value: "1920x1080",
    label: "1920x1080",
  },
  {
    value: "2560x1440",
    label: "2560x1440",
  },
  {
    value: "3840x2160",
    label: "3840x2160",
  },
];

export const CAMERA_CONNECTION_TYPES = [
  {
    label: "FFMPEG",
    value: "FFMPEG",
  },
  {
    label: "VLC",
    value: "VLC",
  },
  {
    label: "JPEG",
    value: "JPEG",
  },
];

export const CAMERA_CONNECTION_PROTOCOLS = [
  {
    label: "HTTP",
    value: "HTTP",
  },
  {
    label: "RTSP",
    value: "RTSP",
  },
];
